import React from 'react';
import {domain} from '../../common/config.js';
import pokerTable from '../../img/pokerTable.png';
import Media from 'react-media'
import RaisedButton from 'material-ui/RaisedButton';
import Fullscreen from "react-full-screen";
import './css/mobile-replayer.css';
import FontAwesome from 'react-fontawesome';
import ReplayerShareDialog  from './ReplayerShareDialog/ReplayerShareDialog'

let baseUrl = "//"+domain+"/images";
export default class MobileReplayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableImage: baseUrl+"/replayerElements/newTable.png",
      playIcon: baseUrl+"/replayerElements/play.png",
      pauseIcon: baseUrl+"/replayerElements/pause.png",
      replay: baseUrl+"/replayerElements/replay.png",
      backward: baseUrl+"/replayerElements/backward.png",
      forward: baseUrl+"/replayerElements/forward.png",
      dealerButton: baseUrl+"/pokerChips/dealerButton.png",
      shareIcon: baseUrl+"/shareIcon.jpg",
      isFull : false,
      gameType:'',
      hamburgerModal: false  ,
    }
  }
  Styles = {
    button: { 
      color: 'white', 
      backgroundColor: '#e8490e',
      border: 'none',
      padding: '10px 30px',
      marginTop: '15px',
      fontSize: '16px',
      fontWeight: 'bold',
      minWidth: '200px',
      borderRadius: 5,
      fontFamily: 'Roboto',
      fontFamily: 'bold'
    }
  }
  ShareModal = (props) => (
    <div className={`rs-modal ${props.isOpen ? 'displayBlock' : 'displayNone'}`} >
      <div className="shareModalCss" >
        <button
          onTouchTap={() => {
            setTimeout(_ => {
              this.setState({hamburgerModal : false})
            }, 100)
          }}
          style={{
            margin: 10,
            justifySelf: 'end',
            color: 'white',
            backgroundColor: '#e8490e',
            border: 'none',
            padding: '2px',
            fontSize: '20px',
            width: 30,
            height: 30,
            borderRadius: 5,
          }}
        >
          <FontAwesome className='centre' name='fas fa-times' />
        </button>
        <img 
          src={`https://${domain}/images/mygame-principal-logo.png`}
          style={{
            width: "20%",
            marginBottom: '20px',
            marginTop: '-35px'
          }}
          />
        <p
          style={{
            maxWidth: "500px",
            fontSize: "16px",
            paddingLeft: '10px',
            paddingRight: '10px',
            fontFamily: 'Roboto'
          }}
        >
          partypoker's free poker coach is here to take your game to the next level
        </p>
        <a href='https://poker.partypoker.com/en/my-game?_nocache=1&_mode=preview' style={this.Styles.button}> Learn More </a>
        <a href='https://poker.partypoker.com/en/promotions/my-game?_nocache=1&_mode=preview' style={this.Styles.button}> Sign Up </a>
      </div>
    </div>
  )
  render() {
    const {
      slide,
      smallBlind,
      bigBlind,
      gameNo,
      playerAlias,
      gameTypeForTitle,
      isShareDialogOpen,
      closeShareDialog,
      openShareDialog,
      replayerScreen,
      partitionDate,
      accountName,
      slideIndex,
      slideLength,
      booster,
      boosterType,
      boosterImages,
      boosterAmount
    } = this.props;

    let overFlow = {};
    if(this.state.hamburgerModal === true) {
      overFlow.overflow = 'hidden'
    }
    let [seat1,seat2,seat3,seat4,seat5,seat6,seat7,seat8,seat9,seat10] = this.props.slide.seats;
    // let seat1,seat2,seat3,seat4,seat5,seat6,seat7,seat8,seat9,seat10;
    // seat1 = this.props.slide.seats[0];
    // seat2 = this.props.slide.seats[0];
    // seat3 = this.props.slide.seats[0];
    // seat4 = this.props.slide.seats[0];
    // seat5 = this.props.slide.seats[0];
    // seat6 = this.props.slide.seats[0];
    // seat7 = this.props.slide.seats[0];
    // seat8 = this.props.slide.seats[0];
    // seat9 = this.props.slide.seats[0];
    // seat10 = this.props.slide.seats[0];
    if(this.props.gameTypeForTitle){
      this.state.gameType =this.props.gameTypeForTitle.charAt(0).toUpperCase()+ this.props.gameTypeForTitle.slice(1)+' '+'Game';
   } 

   function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

   return (
      <Media query="(orientation: portrait)">
        {matches => matches ? (
          <div style={{textAlign:"center"}}>
          <this.ShareModal isOpen={this.state.hamburgerModal}/>
          {replayerScreen !== 'shared' ? 
            <button data-e2e="closeButtonRC" className='closeButtonForOrientation btnHalo' onClick={this.props.onClose}>
                <FontAwesome className='centre' name='fas fa-times' style={{ fontSize: '18px', color: 'white' }} />
            </button> : 
             <button
               style={{
                 backgroundColor: '#de4610',
                 border: 'none',
                 borderRadius: '3px',
                 margin: '10px',
                 float: 'right',
                 width: '30px',
                 height: '30px',
                 padding: 0,
               }}
               onClick={() => {this.setState({ hamburgerModal: true })}}
             >
               <FontAwesome className='centre' name='fas fa-bars'
                 style={{ fontSize: '18px', padding: '2px', color: 'white' }} />
             </button>
          }
            <center>
              <img style={{width:"35%", marginTop: "45%", marginLeft: "10%"}} src={baseUrl+"/replayerElements/orientationCoverNew.png"} />
              <br></br><br></br>
              <h4 style={{fontWeight: "bold", fontSize: "150%",color: "white"}}>TURN YOUR DEVICE</h4>
            </center>
            {this.props.playStatus ? this.props.pause():null}
          </div>
        ) :
        (
           <div className="container">
             <ReplayerShareDialog
               smallBlind={smallBlind}
               bigBlind={bigBlind}
               gameNo={gameNo}
               playerAlias={playerAlias}
               gameType={gameTypeForTitle}
               isOpen={isShareDialogOpen}
               onClose={closeShareDialog}
               partitionDate={partitionDate}
               accountName={accountName}
             />
             <this.ShareModal isOpen={this.state.hamburgerModal}/>
          <div className="gridForTitle">
            <div style={{justifySelf: 'left'}}>
              <span className="titleCss"> {this.props.gameTypeForTitle}</span> <br></br>
              <span className="titleCss"> {this.props.allBlinds}</span> 
            </div>
      {this.props.replayerScreen === 'desktop' ? <div>  
          <button className='shareButton' onClick={openShareDialog}>
              SHARE
          </button>
          <button className='closeButton' onClick={this.props.onClose}> 
              <FontAwesome className='centre' name='fas fa-times' style={{ fontSize: '18px', color: 'white' }} />
          </button> </div> : this.props.replayerScreen === 'fromPlayerDetails' ? <div><button className='closeButton' onClick={this.props.onClose}> 
              <FontAwesome className='centre' name='fas fa-times' style={{ fontSize: '18px', color: 'white' }} />
          </button> </div> :<div>
                     <button
                       style={{
                         backgroundColor: '#de4610',
                         border: 'none',
                         borderRadius: '3px',
                         width: '30px',
                         height: '30px',
                         padding: 0,
                       }}
                       onTouchTap={() => {
                         this.setState({ hamburgerModal: true })
                       }}
                     >
            <FontAwesome className='centre' name='fas fa-bars' 
            style={{ fontSize: '18px',padding: '2px', color: 'white' }} />
            </button>
          </div>}
      </div>
      {/* {(slideIndex === 0 || slideLength-1 === slideIndex) && booster !== "N" && <img className="booster-img" 
                src={`/images/Booster/${boosterImages[boosterType][slideLength-1 === slideIndex?"amount":"normal"]}`} />} */}

    {(slideIndex === 0 || slideLength - 1 === slideIndex) && booster !== "N" &&
          <div className="booster-img-dev">
            <img className="booster-img-desktop"
              src={`https://mygame-dev.mypartypokerlive.com/images/Booster/${boosterImages[boosterType][slideLength - 1 === slideIndex ? "amount" : "normal"]}`} />
              {slideLength-1 === slideIndex && <div className="booster-amount-hands">
                  <span>{`+$`+boosterAmount}</span>
                  </div>}
          </div>}
      <div id="container" style={{height:"80%",marginTop:"27px", ...overFlow}}>

            <div className="tableMv row" id="playerTable">
              <center>
                <div className="col-md-3 col-sm-3 col-xs-3 col-lg-3">
                </div>
                <div className="col-md-6 col-sm-6 col-xs-6 col-lg-6">
                  <img
                    className="mobile-poker-table"
                    src={this.state.tableImage}
                    alt="Poker Table"
                    style={{
                      height:"130%",
                      width:"110%"
                    }}/>
                </div>
                <div className="col-md-3 col-sm-3 col-xs-3 col-lg-3">
                </div>
              </center>
            </div>
               <div
                 className="firstRowPlayerMv row"
                 id="firstRowPlayers"
                 style={{
                   width: 'fit-content',
                   marginLeft: '50%',
                   transform: 'translateX(-50%)'
                 }}
               >
              <div className="col-md-3 col-xs-3">
              </div>
              <div className="col-md-6 col-xs-6">
                <div className="row">
                  <div className="col-md-2 col-xs-2">
                  </div>
                  {/*seat 7*/}
                  <div className="col-md-2 col-xs-2">
                    <div className="row" style={{marginLeft:'2px'}}>
                      <div className="col-md-3 col-xs-3">
                      </div>
                      <div className="col-md-5 col-xs-5" style={{padding: '5px', marginTop: '-30px'}}>
                        <span style={{float: 'right'}}>
                          <div>
                            {(seat7.cards.length == 4)
                              ?seat7.cards.map((card, index) => {
                                return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardOmaha" />
                              })
                              :seat7.cards.map((card, index) => {
                                return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardNormal" />
                              })}
                          </div>
                          <div style={seat7.display.style}>{seat7.display.text}</div>
                          <div style={seat7.coinStack.style}>{numberWithCommas(seat7.coinStack.amount)}</div>
                        </span>
                      </div>
                      <div className="col-md-4 col-xs-4" style={{padding: '5px'}}>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 col-xs-2">
                  </div>
                  {/*seat 8*/}
                  <div className="col-md-2 col-xs-2" >
                    <div className="row" style={{marginLeft:'21px'}}>
                      <div className="col-md-3 col-xs-3">
                      </div>
                      <div className="col-md-5 col-xs-5" style={{padding: '5px', marginTop: '-30px'}}>
                        <span style={{float: 'right'}}>
                          <div>
                            {(seat8.cards.length == 4)
                              ?seat8.cards.map((card, index) => {
                                return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardOmaha"/>
                              })
                              :seat8.cards.map((card, index) => {
                                return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardNormal"/>
                              })}
                          </div>
                          <div style={seat8.display.style}>{seat8.display.text}</div>
                          <div style={seat8.coinStack.style}>{numberWithCommas(seat8.coinStack.amount)}</div>
                        </span>
                      </div>
                      <div className="col-md-4 col-xs-4">
                      </div>
                    </div>
                  </div>
                  {/*seat 9*/}
                  <div className="col-md-2 col-xs-2">
                    <div className="row" style={{marginLeft:'2px'}}>

                      <div className="col-md-5 col-xs-5" style={{padding: '5px', marginTop: '-30px'}}>
                        <span style={{float: 'left'}}>
                          <div>
                            {(seat9.cards.length == 4)
                              ?seat9.cards.map((card, index) => {
                                return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardOmaha"/>
                              })
                              :seat9.cards.map((card, index) => {
                                return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardNormal"/>
                              })}
                          </div>
                          <div style={seat9.display.style}>{seat9.display.text}</div>
                          <div style={seat9.coinStack.style}>{numberWithCommas(seat9.coinStack.amount)}</div>
                        </span>
                      </div>
                      <div className="col-md-7 col-xs-7" style={{padding: '5px'}}>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 col-xs-2">
                  </div>
                </div>
              </div>
              <div className="col-md-3 col-xs-3">
              </div>
            </div>
            <div className="firstRowDealerMv row" id="firstRowDealer" >
              <div className='col-md-3 col-xs-3'>
              </div>
              <div className='col-md-6 col-xs-6'>
                <div className='col-md-2 col-xs-2'>
                </div>
                {/*seat 7 dealer button*/}
                <div className='col-md-1 col-xs-1'>
                  {seat7.dealer
                    ? <img className="dealerButton7" src={this.state.dealerButton} />
                    : <img className="dealerButton7" src={""} />
                  }
                </div>
                <div className='col-md-1 col-xs-1'>
                </div>
                {/*seat 8 dealer button*/}
                <div className='col-md-1 col-xs-1'>
                  {seat8.dealer
                    ? <img
                        src={this.state.dealerButton}
                        className="dealerButton8"
                      />
                    : <img
                        src={""}
                        className="dealerButton8"
                      />
                  }
                </div>
                <div className='col-md-3 col-xs-3'>
                </div>
                {/*seat 9 dealer button*/}
                <div className='col-md-1 col-xs-1'>
                  {seat9.dealer
                    ? <img className="dealerButton9" src={this.state.dealerButton}/>
                    : <img className="dealerButton9" src={""} />
                  }
                </div>
                <div className='col-md-3 col-xs-3'>
                </div>
              </div>
              <div className='col-md-3 col-xs-3'>
              </div>
            </div>
            <div className="firstRowCoinsMv row" id="firstRowCoins" >
              <div className='col-md-3 col-xs-3'>
              </div>
              <div className='col-md-6 col-xs-6'>
                <div className='col-md-1 col-xs-1'>
                </div>
                <div className='col-md-1 col-xs-1'>
                </div>
                {/*seat 7 coins*/}
                <div className='col-md-2 col-xs-2'>
                  <div className="amtSeat7">
                    {/*<div className="row">
                      {seat7.tableStack.imgStack.map((chip, index) => {
                        return (
                          <div className="col-md-2 col-xs-2" style={{float:'right', padding: '0px', position: 'relative'}}>
                            {chip['chip'+index].map((coinUrl, index) => {
                              return <img src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                            })}
                          </div>
                        )
                      })}
                    </div>*/}
                    <div className="row" style={{paddingTop:'25%'}}>
                      {seat7.tableStack.amount > 0
                        ? <span className="mob-playerPotAmt" style={{float:'right'}}>
                          {seat7.tableStack.amount}
                        </span>
                      : null}
                    </div>
                  </div>
                </div>
                <div className='col-md-1 col-xs-1'>
                </div>
                {/*seat 8 coins*/}
                <div className='col-md-2 col-xs-2' >
                  <div className="amtSeat8" >
                    {/*<div className="row">
                      {seat8.tableStack.imgStack.map((chip, index) => {
                        return (
                          <div className="col-md-2 col-xs-2" style={{float:'left', padding: '0px', position: 'relative'}}>
                            {chip['chip'+index].map((coinUrl, index) => {
                              return <img src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                            })}
                          </div>
                        )
                      })}
                    </div>*/}
                    <div className="row" style={{paddingTop:'25%'}}>
                      {seat8.tableStack.amount > 0
                        ? <span className="mob-playerPotAmt" style={{float:'left'}}>
                          {seat8.tableStack.amount}
                        </span>
                        : null}
                    </div>
                  </div>
                </div>
                <div className='col-md-1 col-xs-1'>
                </div>
                {/*seat 9 coins*/}
                <div className='col-md-2 col-xs-2'>
                  <div className="amtSeat9">
                    {/*<div className="row">
                      {seat9.tableStack.imgStack.map((chip, index) => {
                        return (
                          <div className="col-md-2 col-xs-2" style={{float:'left', padding: '0px', position: 'relative'}}>
                            {chip['chip'+index].map((coinUrl, index) => {
                              return <img src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                            })}
                          </div>
                        )
                      })}
                    </div>*/}
                    <div className="row" style={{paddingTop:'25%'}}>
                      {seat9.tableStack.amount > 0
                        ? <span className="mob-playerPotAmt" style={{float:'left'}}>
                            {seat9.tableStack.amount}
                          </span>
                      : null}
                    </div>
                  </div>
                </div>
                <div className='col-md-2 col-xs-2'>
                </div>
              </div>
              <div className='col-md-3 col-xs-3'>
              </div>
            </div>
            <div className="tablePotMv row" id="tablePot" >
              <div className="col-md-2 col-xs-2">
              </div>
              {/*seat 6 display*/}
              <div className="col-md-1 col-xs-1">
                <div className="seat6CardsAndAmtBox row">
                  <div className="col-md-7 col-xs-7">
                  </div>
                  <div className="col-md-5 col-xs-5" style={{padding: '5px', marginTop: '-50px'}}>
                    <span style={{float: 'right'}}>
                      <div>
                        {(seat6.cards.length == 4)
                          ?seat6.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardOmaha" />
                          })
                          :seat6.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardNormal" />
                        })}
                      </div>
                      <div style={seat6.display.style}>{seat6.display.text}</div>
                      <div style={seat6.coinStack.style}>{numberWithCommas(seat6.coinStack.amount)}</div>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xs-6">
                <div className="row">
                  <div className="col-md-1 col-xs-1">
                  </div>
                  {/*seat 6 dealer+coins*/}
                  <div className="col-md-2 col-xs-2">
                    {seat6.dealer
                      ? <img className="dealerButton6" src={this.state.dealerButton} />
                      : <img className="dealerButton6" src={""} />
                    }
                    <div className="amtSeat6">
                      {/*<div className="row">
                        {seat6.tableStack.imgStack.map((chip, index) => {
                          return (
                            <div className="col-md-2 col-xs-2" style={{float:'left', padding: '0px', position: 'relative'}}>
                              {chip['chip'+index].map((coinUrl, index) => {
                                return <img src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                              })}
                            </div>
                          )
                        })}
                      </div>*/}
                      <div>
                        {seat6.tableStack.amount > 0
                        ? <span className="mob-playerPotAmt" style={{float:'left'}}>
                            {seat6.tableStack.amount}
                          </span>
                        : null}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 col-xs-2">

                  </div>
                  <div className="col-md-2 col-xs-2">
                    {/*<div className="row">
                      {this.props.slide.pot.imgStack.map((chip, index) => {
                        return (
                          <div className="col-md-2 col-xs-2" style={{padding: '0px', position: 'relative'}}>
                            {chip['chip'+index].map((coinUrl, index) => {
                              return <img src={coinUrl} style={{width: '110%', position: 'absolute', top: index*(-3)}}/>
                            })}
                            </div>
                        )
                      })}
                    </div>*/}
                    <div>
                      {this.props.slide.pot.amount > 0
                      ? <span className="mob-playerPotAmt">
                          {this.props.slide.pot.amount}
                        </span>
                      : null}
                    </div>
                  </div>
                  <div className="col-md-2 col-xs-2">
                  </div>
                  {/*seat 10 dealer + coins*/}
                  <div className="col-md-2 col-xs-2">
                    {seat10.dealer
                      ? <img className="dealerButton10" src={this.state.dealerButton} />
                      : <img className="dealerButton10" src={""} />
                    }
                    {/*<div style={{marginRight:"30%",marginLeft:"10%"}}>*/}
                    {/*<div className="row">
                        {seat10.tableStack.imgStack.map((chip, index) => {
                          return (
                            <div className="col-md-2 col-xs-2" style={{float:'right', padding: '0px', position: 'relative'}}>
                              {chip['chip'+index].map((coinUrl, index) => {
                                return <img src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                              })}
                            </div>
                          )
                        })}
                      </div>*/}
                      <div className="amtSeat10" >
                        {seat10.tableStack.amount > 0
                        ? <span className="mob-playerPotAmt" style={{float:'right'}}>
                            {seat10.tableStack.amount}
                          </span>
                        : null}
                      </div>
                    {/*</div>*/}
                  </div>
                  <div className="col-md-1 col-xs-1">
                  </div>
                </div>
              </div>
              {/*Seat 10 display*/}
              <div className="col-md-1 col-xs-1">
                <div className="seat10CardsAndAmtBox row" >
                  <div className="col-md-7 col-xs-7" style={{padding: '5px'}}>

                  </div>
                  <div className="col-md-5 col-xs-5" style={{padding: '5px', marginTop: '-30px'}}>
                    <span style={{float: 'left'}}>
                      <div>
                      {(seat10.cards.length == 4)
                        ?seat10.cards.map((card, index) => {
                          return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardOmaha" />
                        })
                        :seat10.cards.map((card, index) => {
                          return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardNormal" />
                        })}
                        </div>
                        <div style={seat10.display.style}>{seat10.display.text}</div>
                        <div style={seat10.coinStack.style}>{numberWithCommas(seat10.coinStack.amount)}</div>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-xs-2">
              </div>
            </div>
            <div className="tableCardsMV row" id="tableCards" >
              <div className="col-md-2 col-xs-2">
              </div>
              {/*Seat 5 display*/}
              <div className="col-md-1 col-xs-1">
                <div className="seat5CardsAndAmtBox row" >
                  <div className="col-md-5 col-xs-6" style={{padding: '5px', marginTop: '-30px'}}>
                    <span style={{float: 'right'}}>
                      <div>
                        {(seat5.cards.length == 4)
                          ?seat5.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardOmaha" />
                          })
                          :seat5.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardNormal" />
                          })}
                      </div>
                      <div style={seat5.display.style}>{seat5.display.text}</div>
                      <div style={seat5.coinStack.style}>{numberWithCommas(seat5.coinStack.amount)}</div>
                    </span>
                  </div>
                  <div className="col-md-7 col-xs-6" style={{padding: '5px'}}>
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-xs-6">
                <div className="row">
                  <div className="col-md-1 col-xs-1">
                  </div>
                    {/*seat 5 dealer + cards*/}
                    <div className="col-md-2 col-xs-2">
                      {seat5.dealer
                        ? <img className="dealerButton5" src={this.state.dealerButton} />
                        : <img className="dealerButton5" src={""} />
                      }
                      {/*<div className="row">
                        {seat5.tableStack.imgStack.map((chip, index) => {
                          return (
                            <div className="col-md-2 col-xs-2" style={{float:'left', padding: '0px', position: 'relative'}}>
                              {chip['chip'+index].map((coinUrl, index) => {
                                return <img src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                              })}
                            </div>
                          )
                        })}
                      </div>*/}
                      <div className="amtSeat5">
                        {seat5.tableStack.amount > 0
                          ? <span className="mob-playerPotAmt" style={{float:'left'}}>
                              {seat5.tableStack.amount}
                            </span>
                        : null}
                      </div>
                  </div>
                  <div className="col-md-1 col-xs-1">
                  </div>
                  <div className="middleCardsMv col-md-4 col-xs-4">
                    <div className="middleCardsSize">
                      {this.props.slide.dealerCards.map((card, index) => {
                        return <img key={index} id={card.imgId} src={card.imgUrl} style={{paddingRight:' 0.2em', width: '20%'}}/>
                      })}
                    </div>
                  </div>
                  <div className="col-md-1 col-xs-1">
                  </div>
                  {/*seat 1 dealer + coins*/}
                  <div className="col-md-2 col-xs-2">
                      {seat1.dealer
                        ? <img className={`dealerButton1 ${this.props.slide.dealerCards.length > 0 ? 'dealerButtonWithCards':'dealerButtonWithoutCards'}`} src={this.state.dealerButton} />
                        : <img className="dealerButton1" src={""} />
                      }
                    <div style={{marginTop:"-80%",marginLeft:"10%"}}>
                      {/*<div className="row">
                        {seat1.tableStack.imgStack.map((chip, index) => {
                          return (
                            <div className="col-md-2 col-xs-2" style={{float:'right', padding: '0px', position: 'relative'}}>
                            {chip['chip'+index].map((coinUrl, index) => {
                              return <img src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                            })}
                            </div>
                          )
                        })}
                      </div>*/}
                      <div className={`amtSeat1 ${this.props.slide.dealerCards.length > 0 ? 'amtBoxWithCards':'amtBoxWithoutCards'}`}>
                        {seat1.tableStack.amount > 0
                          ? <span className="mob-playerPotAmt" style={{float:'right'}}>
                            {seat1.tableStack.amount}
                            </span>
                        : null}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-1 col-xs-1">
                  </div>
                </div>
              </div>
              {/*seat 1 dealer + cards*/}
              <div className="col-md-1 col-xs-1">
                <div className="seat1CardsAndAmtBox row">
                  <div className="col-md-7 col-xs-7" style={{padding: '5px'}}>
                  </div>
                  <div className="col-md-5 col-xs-5" style={{padding: '5px', marginTop: '-30px'}}>
                    <span style={{float: 'left'}}>
                      <div>
                        {(seat1.cards.length == 4)
                          ?seat1.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardOmaha" />
                          })
                          :seat1.cards.map((card, index) => {
                            return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardNormal" />
                          })}
                      </div>
                      <div style={seat1.display.style}>{seat1.display.text}</div>
                      <div style={seat1.coinStack.style}>{numberWithCommas(seat1.coinStack.amount)}</div>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-2 col-xs-2">
              </div>
            </div>
            <div className="secondRowCoinsMv row" id="secondRowCoins" >
              <div className='col-md-3 col-xs-3'>
              </div>
              <div className='col-md-6 col-xs-6'>
                <div className='col-md-2 col-xs-2'>
                </div>
                {/*seat 4 coins*/}
                  <div className='col-md-2 col-xs-2'>
                    <div className="amtSeat4">
                      {/*<div className="row">
                        {seat4.tableStack.imgStack.map((chip, index) => {
                          return (
                            <div className="col-md-2 col-xs-2" style={{float:'right', padding: '0px', position: 'relative'}}>
                              {chip['chip'+index].map((coinUrl, index) => {
                                return <img src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                              })}
                            </div>
                          )
                        })}
                      </div>*/}
                      <div className="row" style={{paddingTop:'25%'}}>
                        {seat4.tableStack.amount > 0
                        ? <span className="mob-playerPotAmt" style={{float:'right'}}>
                            {seat4.tableStack.amount}
                          </span>
                        : null}
                      </div>
                    </div>
                  </div>
                  <div className='col-md-2 col-xs-2'>
                  </div>
                  {/*seat 3 coins*/}
                  <div className='col-md-2 col-xs-2' >
                    <div className="amtSeat3">
                      {/*<div className="row">
                        {seat3.tableStack.imgStack.map((chip, index) => {
                          return (
                            <div className="col-md-2 col-xs-2" style={{float:'left', padding: '0px', position: 'relative'}}>
                            {chip['chip'+index].map((coinUrl, index) => {
                              return <img src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                            })}
                            </div>
                          )
                        })}
                      </div>*/}
                      <div className="row" style={{paddingTop:'25%'}}>
                        {seat3.tableStack.amount > 0
                        ? <span className="mob-playerPotAmt" style={{float:'left'}}>
                          {seat3.tableStack.amount}
                          </span>
                        : null}
                      </div>
                    </div>
                  </div>
                  <div className='col-md-1 col-xs-1'>
                  </div>
                  {/*seat 2 coins*/}
                  <div className='col-md-2 col-xs-2'>
                    <div className="amtSeat2">
                      {/*<div className="row">
                        {seat2.tableStack.imgStack.map((chip, index) => {
                          return (
                            <div className="col-md-2 col-xs-2" style={{float:'left', padding: '0px', position: 'relative'}}>
                              {chip['chip'+index].map((coinUrl, index) => {
                                return <img src={coinUrl} style={{width: '100%', position: 'absolute', top: index*(-3)}}/>
                              })}
                            </div>
                          )
                        })}
                      </div>*/}
                      <div className="row" style={{paddingTop:'25%'}}>
                        {seat2.tableStack.amount > 0
                        ? <span className="mob-playerPotAmt" style={{float:'left'}}>
                            {seat2.tableStack.amount}
                          </span>
                        : null}
                      </div>
                    </div>
                  </div>
                  <div className='col-md-1 col-xs-1'>
                  </div>
                </div>
              <div className='col-md-3 col-xs-3'>
              </div>
            </div>

            <div className="secondRowDealerMv row" id="secondRowDealer" >
              <div className='col-md-3 col-xs-3'>
              </div>
              <div className='col-md-6 col-xs-6'>
                <div className='col-md-2 col-xs-2'>
                </div>
                {/*seat 4 dealer*/}
                <div className='col-md-1 col-xs-1'>
                  {seat4.dealer
                    ? <img className="dealerButton4" src={this.state.dealerButton} style={{width: '10px', marginTop:"-30px"}}/>
                    : <img className="dealerButton4" src={""} style={{width: '10px', marginTop:"-30px"}}/>
                  }
                </div>
                <div className='col-md-1 col-xs-1'>
                </div>
                {/*seat 3 dealer*/}
                <div className='col-md-1 col-xs-1'>
                  {seat3.dealer
                    ? <img className="dealerButton3" src={this.state.dealerButton} style={{width: '10px', marginTop:'-20px'}}/>
                    : <img className="dealerButton3" src={""} style={{width: '10px', marginTop:'-20px'}}/>
                  }
                </div>
                <div className='col-md-3 col-xs-3'>
                </div>
                {/*seat 2 dealer*/}
                <div className='col-md-1 col-xs-1'>
                  {seat2.dealer
                    ? <img className="dealerButton2" src={this.state.dealerButton} style={{width: '10px', marginTop:'-30px'}}/>
                    : <img className="dealerButton2" src={""} style={{width: '10px', marginTop:'-30px'}}/>
                  }
                </div>
                <div className='col-md-3 col-xs-3'>
                </div>
              </div>
              <div className='col-md-3 col-xs-3'>
              </div>
            </div>

            <div className="secondRowPlayersMv row" id="secondRowPlayers">
              <div className="playAndReplayBox col-md-2 col-xs-2">
                {/* {this.props.slide.description ? this.props.slide.description.trim().split("\n").map(descp => {
                  return <span>{descp}<br/></span>
                }):null} */}
                {!this.props.playStatus
                  ? <img className='playButton' src={this.state.playIcon} onTouchTap={this.props.play} />
                  : <img className='playButton' src={this.state.pauseIcon} onTouchTap={this.props.pause} />
                }
                <img className='replayButton' src={this.state.replay} onTouchTap={this.props.refresh} />
              </div>
              <div className="col-md-1 col-xs-1">
              </div>
              <div className="col-md-6 col-xs-6">
                <div className="row">
                  <div className="col-md-2 col-xs-2">
                  </div>
                  {/*seat 4*/}
                  <div className="col-md-2 col-xs-2">
                    <div className="row" style={{marginLeft:'2px'}}>
                      <div className="col-md-5 col-xs-6" style={{padding: '5px', marginTop: '-30px'}}>
                        <span style={{float: 'right', marginTop:'100%'}}>
                          <div>
                            {(seat4.cards.length == 4)
                            ?seat4.cards.map((card, index) => {
                              return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardOmaha" />
                            })
                            :seat4.cards.map((card, index) => {
                              return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardNormal" />
                            })}
                          </div>
                          <div style={seat4.display.style}>{seat4.display.text}</div>
                          <div style={seat4.coinStack.style}>{numberWithCommas(seat4.coinStack.amount)}</div>
                        </span>
                      </div>
                      <div className="col-md-7 col-xs-6" style={{padding: '5px'}}>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 col-xs-2">
                  </div>
                  {/*seat 3*/}
                  <div className="col-md-2 col-xs-2" style={{marginLeft: '20px'}} >
                    <div className="row" style={{marginLeft:'2px'}}>
                      <div className="col-md-5 col-xs-6" style={{padding: '5px', marginTop: '-30px'}}>
                        <span style={{float: 'right', marginTop:'100%'}}>
                          <div>
                            {(seat3.cards.length == 4)
                            ?seat3.cards.map((card, index) => {
                              return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardOmaha"/>
                            })
                            :seat3.cards.map((card, index) => {
                              return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardNormal"/>
                            })}
                          </div>
                          <div style={seat3.display.style}>{seat3.display.text}</div>
                          <div style={seat3.coinStack.style}>{numberWithCommas(seat3.coinStack.amount)}</div>
                        </span>
                      </div>
                      <div className="col-md-7 col-xs-6" style={{padding: '5px'}}>
                      </div>
                    </div>
                  </div>

                  {/*seat 2*/}
                  <div className="col-md-2 col-xs-2" style={{marginLeft: '-26px'}}>
                    <div className="row" style={{marginLeft:'2px'}}>
                      <div className="col-md-7 col-xs-7" style={{padding: '5px'}}>
                      </div>
                      <div className="col-md-5 col-xs-5" style={{padding: '5px', marginTop: '-30px'}}>
                        <span style={{float: 'left', marginTop:'100%'}}>
                          <div>
                            {(seat2.cards.length == 4)
                              ?seat2.cards.map((card, index) => {
                                return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardOmaha"/>
                              })
                              :seat2.cards.map((card, index) => {
                                return <img key={index} id={card.imgId} src={card.imgUrl} className = "mob-SeatCardNormal"/>
                              })}
                          </div>
                          <div style={seat2.display.style}>{seat2.display.text}</div>
                          <div style={seat2.coinStack.style}>{numberWithCommas(seat2.coinStack.amount)}</div>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-2 col-xs-2">
                  </div>
                </div>
              </div>
              <div className="ForwardAndBackwardBox col-md-3 col-xs-3">
                <img className="backwardAndForwordButton" src={this.state.backward} onTouchTap={this.props.stepBackward} />
                <img className="backwardAndForwordButton" src={this.state.forward} onTouchTap={this.props.stepForward} />
              </div>
            </div>
          </div>
             </div>
        )}
      </Media>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/HandReplayer/MobileReplayer.js
 **/